import { ReactNode } from "react";
import { useUserRole } from "@/hooks/useUserRole";
import PMSidebar from "@/components/pm/PMSidebar";

// The /projects pages are shared (customers post renovation projects). When a Property Manager
// opens them from the PM sidebar, keep their sidebar + layout offset so they don't lose navigation.
// Customers (and everyone else) get the pages unchanged, with no sidebar.
export function ProjectsChrome({ children }: { children: ReactNode }) {
  const { isPropertyManager } = useUserRole();

  if (!isPropertyManager) return <>{children}</>;

  return (
    <div className="lg:pl-64">
      <PMSidebar active="projects" />
      {children}
    </div>
  );
}
